<maf-button *ngIf="lojaUrlVoltar.length > 0" (click)="voltar()"><i class="fas fa-arrow-left"></i> voltar</maf-button>

<h1>Encontre a loja mais perto de você</h1>

<div *ngIf="isLoading" class="loading-app">
  <i class="far fa-circle-notch fa-spin fa-3x fa-fw"></i>
  <p>carregando lojas, aguarde...</p>
</div>

<div *ngIf="!isLoading && lojas != null && lojas.listLoja.length > 0 && !isDetalhesLoja" class="card-container">
  <div *ngFor="let loja of lojas.listLoja" class="card">
    <div (click)="abrirDetalhesLoja(loja)" class="titulo">
      <div class="titulo-esq">{{loja.fantasia}}</div>
      <div class="titulo-dir">{{loja.cidade}}</div>
    </div>
    <div class="endereco-loja">
      <div (click)="abrirDetalhesLoja(loja)" class="endereco-loja-texto">
        {{loja.logradouro}}, {{loja.numero}} - {{loja.bairro}}
      </div>
      <div (click)="mapa(loja)" class="endereco-loja-icone">
        <i class="fad fa-map-marked-alt" style="--fa-primary-color: #e75546; --fa-secondary-color: #34a853;"></i>
      </div>
    </div>
    <div (click)="abrirDetalhesLoja(loja)" class="vendedor-loja">
      <a>{{getQtdVendedores(loja.codEmpresa)}} Vendedor{{getQtdVendedores(loja.codEmpresa) == 1 ? '' : 'es'}}</a>
    </div>
  </div>
</div>

<div *ngIf="!isLoading && lojas != null && lojas.listLoja.length == 0 && !isDetalhesLoja" class="lista-vazia">
  Não foi encontrado nenhuma loja.
</div>

<div class="detalhe-loja">
  <maf-button *ngIf="isDetalhesLoja" (click)="fecharDetalhesLoja()"><i class="fas fa-arrow-left"></i> lojas</maf-button>
  <div #divLoadVendedoresComponent></div>
</div>
